import { jsx as _jsx } from "react/jsx-runtime";
import { GRID_UNIT } from '../../../../utilities/grid';
import { Margin } from '../../../../utilities/margin';
import { Text } from '../../../Text';
import { Paragraph } from '../Paragraph';
export var Heading = function (_a) {
  var children = _a.children,
    level = _a.level;
  if (level > 1 && level <= 4) {
    return _jsx(Margin, {
      top: GRID_UNIT * 4,
      bottom: GRID_UNIT,
      children: _jsx(Text, {
        el: getMappedElement(level),
        styleName: getMappedStyleName(level),
        children: children
      })
    });
  }
  return _jsx(Paragraph, {
    children: children
  });
};
// --- Helpers
var getMappedElement = function (level) {
  switch (level) {
    case 2:
      return 'h2';
    case 3:
      return 'h3';
    case 4:
      return 'h4';
    default:
      return 'p';
  }
};
var getMappedStyleName = function (level) {
  switch (level) {
    case 2:
      return 'title5';
    case 3:
      return 'title7';
    case 4:
      return 'title8';
    default:
      return 'bodyRegular';
  }
};